<template>
    <div class="box">
        <div class="box-header p-b-sm">
            <h2 class="title-color m-b-sm">Dostaw</h2>
            <div class="m-t-sm custom-divider"/>

            <!-- Preferencje dostawy -->
            <div class="row m-b-sm">
                <label class="col-sm-6 col-md-6 form-control-label">Preferowana dostawa</label>
                <div class="col-sm-6 col-md-6">
                    <v-select placeholder="Nie wybrano" label="name" v-model="order.deliveryType" :options="deliveryTypes" @input="saveDelivery" />
                </div>
            </div>

            <!-- Preferowany przewoźnik -->
            <div class="row m-b-sm">
                <label class="col-sm-6 col-md-6 form-control-label">Preferowany przewoźnik</label>
                <div class="col-sm-6 col-md-6">
                    <v-select placeholder="Nie wybrano" label="name" v-model="order.deliveryCompany" :options="deliveryCompanies" @input="saveDelivery" />
                </div>
            </div>

            <!-- Zamówienie za pobraniem -->
            <div class="row m-b-sm">
                <div class="col-sm-12">
                    <label class="md-check">
                        <input type="checkbox" @change="saveDelivery" v-model="order.deliveryIsCod">
                        <i class="blue m-r-xs"/>
                        <span class="m-l-xs">Zamówienie za pobraniem</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="m-a-0 custom-divider"/>

        <!-- Wybrany adres dostawy -->
        <div class="box-body p-t-0">
            <div class="row m-b-sm">
                <label class="col-sm-12 form-control-label">Wybrany adres dostawy</label>
            </div>
            <div class="row" v-if="selectedDeliveryAddress">
                <div class="col-sm-6">
                    <strong>{{selectedDeliveryAddress.name}}</strong><br>
                    {{selectedDeliveryAddress.street}}<br>
                    {{selectedDeliveryAddress.postCode}} {{selectedDeliveryAddress.city}}
                    <span v-if="selectedDeliveryAddress.countryCode">({{selectedDeliveryAddress.countryCode}})</span><br>
                    <span v-if="selectedDeliveryAddress.phone">{{selectedDeliveryAddress.phone}}<br></span>
                    <span v-if="selectedDeliveryAddress.email">{{selectedDeliveryAddress.email}}<br></span>
                    <span v-if="selectedDeliveryAddress.contactPerson">Osoba do kontaktu: {{selectedDeliveryAddress.contactPerson}}<br></span>
                </div>
                <div class="col-md-6" v-if="selectedDeliveryAddress.activeOrders && selectedDeliveryAddress.activeOrders.length">
                    <span class="label m-r-xs c-green">{{ selectedDeliveryAddress.activeOrders.length }} akt. {{ selectedDeliveryAddress.activeOrders.length === 1 ? 'zamówienie' : selectedDeliveryAddress.activeOrders.length < 5 ? 'zamówienia' : 'zamówień' }} z tym adresem</span><br/>
                    <span class="text-xs" v-for="(o, idx) in selectedDeliveryAddress.activeOrders.slice(0, 3)" :key="o._id">
                        <a :href="'#/order/' + o._id" target="_blank">{{ o.name || o._id }}</a><span v-if="idx < selectedDeliveryAddress.activeOrders.slice(0, 3).length - 1">, </span>
                    </span>
                    <span class="text-xs text-muted" v-if="selectedDeliveryAddress.activeOrders.length > 3"> i {{ selectedDeliveryAddress.activeOrders.length - 3 }} więcej</span>
                </div>
            </div>
            <div v-else class="text-muted">
                Brak wybranego adresu dostawy
            </div>

            <!-- Ostrzeżenie: inne aktywne zamówienia z innym adresem dostawy -->
            <div v-if="differentActiveAddresses.length" class="attention-box m-t-sm">
                <div class="header">
                    <i class="fa fa-exclamation-triangle m-r-xs"></i>
                    <strong>Uwaga</strong> — inne aktywne zamówienia tego klienta używają innego adresu dostawy
                </div>
                <div
                    v-for="item in differentActiveAddresses"
                    :key="item.address._id"
                    class="item"
                >
                    <div class="box-body">
                        <div class="diff-addr-name">{{ item.address.name }}</div>
                        <div class="diff-addr-line">{{ item.address.street }}</div>
                        <div class="diff-addr-line">
                            {{ item.address.postCode }} {{ item.address.city }}
                            <span v-if="item.address.countryCode">({{ item.address.countryCode }})</span>
                        </div>
                        <div class="diff-addr-orders">
                            <span class="diff-addr-count">{{ item.orders.length }} {{ item.orders.length === 1 ? 'zamówienie' : item.orders.length < 5 ? 'zamówienia' : 'zamówień' }}</span>
                            <span v-for="(o, idx) in item.orders.slice(0, 3)" :key="o._id">
                                <a :href="'#/order/' + o._id" target="_blank">{{ o.name || o._id }}</a><span v-if="idx < item.orders.slice(0, 3).length - 1">, </span>
                            </span>
                            <span v-if="item.orders.length > 3" class="text-muted"> i {{ item.orders.length - 3 }} więcej</span>
                        </div>
                    </div>
                    <div class="box-footer">
                        <button
                            class="btn btn-xs btn-warning none-radius"
                            @click="useAddressForOrder(item.address._id)"
                        >
                            <i class="fa fa-check m-r-xs"></i>Użyj tego adresu
                        </button>
                    </div>
                </div>
            </div>

            <div class="row m-t-sm">
                <div class="col-sm-12">
                    <button class="btn btn-xs white none-radius" @click="showAddressList = !showAddressList">
                        {{ showAddressList ? 'Ukryj listę adresów' : 'Zmień adres' }}
                    </button>
                </div>
            </div>

            <!-- Lista adresów dostawy -->
            <div v-if="showAddressList" class="m-t-sm">
                <input
                    type="text"
                    class="form-control m-b-sm"
                    placeholder="Filtruj adres..."
                    v-model="addressFilter"
                >
                <div class="address-list">
                    <div
                        v-for="addr in filteredDeliveryAddresses"
                        :key="addr._id"
                        class="address-item m-b-xs"
                        :class="{ 'address-item--active': addr._id === order.deliveryAddressId }"
                        @click="selectAddress(addr._id)"
                    >
                        <strong>{{ addr.name }}</strong><br>
                        {{ addr.street }}<br>
                        {{ addr.postCode }} {{ addr.city }}
                        <span v-if="addr.countryCode">({{ addr.countryCode }})</span>
                        <span v-if="addr.phone"><br>{{ addr.phone }}</span>
                        <span v-if="addr.email"><br>{{ addr.email }}</span>
                        <span v-if="addr.contactPerson"><br>Kontakt: {{ addr.contactPerson }}</span>
                    </div>
                    <div v-if="filteredDeliveryAddresses.length === 0" class="text-muted">
                        Brak adresów pasujących do filtra
                    </div>
                </div>
            </div>
        </div>

        <div class="m-a-0 custom-divider"/>
    </div>
</template>
<script>
import Api from '../../Api.js';
import EditDelvieryCustomerModal from '../Customers/EditDelvieryCustomerModal.vue'
import { DELIVERY_TYPES, DELIVERY_PROVIDERS } from '../../Common.js'

export default {
    name: 'Customer',
    props: {
        order: Object
    },
    data: function () {
        return {
            showAddressList: false,
            addressFilter: '',
            deliveryTypes: Object.keys(DELIVERY_TYPES),
            deliveryCompanies: DELIVERY_PROVIDERS,
            customerActiveOrders: []
        }
    },
    computed: {
        filteredDeliveryAddresses: function() {
            const addresses = this.order.customer.deliveryAddresses || [];
            const q = this.addressFilter.toLowerCase().trim();
            if (!q) return addresses;
            return addresses.filter(addr => {
                return [
                    addr.name, addr.street, addr.postCode,
                    addr.city, addr.countryCode, addr.phone,
                    addr.email, addr.contactPerson
                ].some(val => val && val.toLowerCase().includes(q));
            });
        },

        selectedDeliveryAddress: function() {
            if (!this.order.deliveryAddressId) {
                return null;
            }

            const address = this.order.customer.deliveryAddresses.find(addr => addr._id === this.order.deliveryAddressId) || null;
            if (!address) return null;

            const activeOrdersWithSameAddress = this.customerActiveOrders.filter(o => this.order._id != o._id && address._id == o.deliveryAddressId);
            address.activeOrders = activeOrdersWithSameAddress.length ? activeOrdersWithSameAddress : [];

            return address;
        },

        differentActiveAddresses: function() {
            if (!this.order.deliveryAddressId) return [];
            const seenAddressIds = new Set();
            const result = [];
            for (const o of this.customerActiveOrders) {
                if (o._id === this.order._id) continue;
                if (!o.deliveryAddressId) continue;
                if (o.deliveryAddressId === this.order.deliveryAddressId) continue;
                if (seenAddressIds.has(o.deliveryAddressId)) continue;
                seenAddressIds.add(o.deliveryAddressId);
                const addr = (this.order.customer.deliveryAddresses || []).find(a => a._id === o.deliveryAddressId);
                if (addr) {
                    const ordersWithThisAddr = this.customerActiveOrders.filter(x => x._id !== this.order._id && x.deliveryAddressId === o.deliveryAddressId);
                    result.push({ address: addr, orders: ordersWithThisAddr });
                }
            }
            return result;
        }
    },

    created: async function() {
        try {
            // search similar active orders of the same customer to suggest copying delivery address from them
            this.customerActiveOrders = await Api.order.search({ customer: this.order.customer._id, status: ['waiting-room', 'waiting-for-prod', 'in-production', 'ready-to-pack', 'packed-to-confirm', 'pack', 'ready-to-send'] });
        } catch (e) {
            this.$h.commonApiError(e);
        }
    },

    methods: {
        selectAddress: function(addressId) {
            Api.order.setDeliverAddress(this.order._id, addressId).then(() => {
                this.order.deliveryAddressId = addressId;
                this.showAddressList = false;
                this.addressFilter = '';
                this.$h.success("Zapisano adres dostawy dla zlecenia");
            });
        },

        useAddressForOrder: function(addressId) {
            Api.order.setDeliverAddress(this.order._id, addressId).then((order) => {
                this.order.deliveryAddressId = addressId;
                this.$h.success("Zapisano adres dostawy dla zlecenia");
            });
        },

        saveDelivery: async function() {
            try {
                await Api.order.save(this.order._id, { deliveryType: this.order.deliveryType, deliveryCompany: this.order.deliveryCompany, deliveryIsCod: this.order.deliveryIsCod });
                this.$h.success("Pomyślnie zmieniono preferowany rodzaj dostawy");
            } catch (e) {
                this.$h.commonApiError(e);
            }
        },

        addDeliveryAddress: async function() {
            const adress = {
                name: this.order.customer.name,
                street: this.order.customer.street,
                postCode: this.order.customer.postCode,
                city: this.order.customer.city,
                countryCode: this.order.customer.countryCode,
                phone: this.order.customer.phone
            };
            const res = await this.$modal2.show(EditDelvieryCustomerModal, {
                customer: this.order.customer,
                delivery: adress
            });
            if (res) this.order.customer = res;
        }
    }
}
</script>
<style scoped lang="scss">
.address-list {
    max-height: 400px;
    overflow-y: auto;
}

.address-item {
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid transparent;

    &:hover {
        background-color: #eef4ff;
        border-color: #b3cef5;
    }

    &--active {
        border-color: #5b9bd5;
        background-color: #e8f0fb;
    }
}

.diff-addr-name {
    font-weight: 600;
    color: var(--dm-text, #333);
}

.diff-addr-line {
    color: #555;
}

.diff-addr-orders {
    margin-top: 3px;
    font-size: 0.85em;
    color: var(--dm-text-muted, #777);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    a {
        color: var(--dm-text-muted, #888);
        text-decoration: underline;
    }
}

.diff-addr-count {
    display: inline-block;
    background: #f5c842;
    color: #5a3e00;
    border-radius: 3px;
    padding: 0 5px;
    font-weight: 600;
    margin-right: 5px;
    font-size: 0.9em;
}

</style>
